import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { UseStylesProps } from './CircularProgress.types';

export const useStyles = makeStyles<Theme, UseStylesProps>(({ palette, spacing, typography: { fontWeightBold } }) =>
  createStyles({
    container: {
      position: 'relative',
      height: ({ size }) => size,
    },
    bottom: {
      color: palette.gray.light,
    },
    top: {
      color: '#18a957',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },
    value: {
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-47%, -50%)',
      fontSize: spacing(2.5),
      color: '#5dc389',
      fontWeight: fontWeightBold,
      lineHeight: spacing(2.125),
      display: 'flex',
      justifyContent: 'center',
    },
  }),
);
